import axios from 'axios';
import { actionCreators as Delivery } from '../../../actions';
import handleError from '../../../../../../../components/FormHelpers/handleError';

const submitForm = async (values, next, dispatch, setError) => {
  const { deliveryId, mobileNo } = values;

  try {
    const response = await axios.get(`/api/deliveries/${deliveryId}`, {
      params: {
        mobileNo: mobileNo
      }
    });

    if (!process.env.NODE_ENV || ['development', 'test'].includes(process.env.NODE_ENV)) {
      alert(response.data.testAuthCode);
    }

    dispatch(Delivery.setOrderId(response.data.id));
    next();
  } catch (err) {
    handleError(err.response, setError);
    throw err;
  }
};

export default submitForm;
